// extracted by mini-css-extract-plugin
export var equalColumn = "_it-0";